import React, { createContext, useContext, ReactNode } from 'react';
import { useTheme } from '../hooks/useTheme';
import type { ThemeContextProps, ThemeMode } from '../types';

// Create context with a default value
const ThemeContext = createContext<ThemeContextProps>({
  theme: 'system',
  setTheme: () => {},
  isDark: false,
});

// Custom hook to use the theme context
export const useThemeContext = () => useContext(ThemeContext);

// Provider component
export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const themeValue = useTheme();
  
  return (
    <ThemeContext.Provider value={themeValue}>
      {children}
    </ThemeContext.Provider>
  );
};

// Utility functions for theme
export const setTheme = (theme: ThemeMode) => {
  if (typeof window === 'undefined') return;
  
  localStorage.setItem('theme', theme);
  
  if (theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
};